import React, { useState } from "react";
import "../../styles/ChecklistCard.css";
import ChecklistCard from "../../components/ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import importantNotes from "../../data/Saskatchewan/importantNotes.js";
import ImportantNotes from "../../components/ImportantNotes.js";

export default function Referral() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const PreConReferralData = [
    "Builder's Sale Agreement w/ Tarion Addendums",
    "Builder Referral/Commission Agreement or FORM 641 if Builder does not have a Referral Form",
  ];

  const ReferralData = [
    "Referral Agreement (641)",
    "Full REALTOR® SOLD MLS Printout",
  ];

  const handleReferralType = (e) => {
    setReferralType(e.target.value);
  };

  const [ReferralType, setReferralType] = useState(
    "Client Referral to another Agent"
  );

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <ThemeProvider theme={theme}>
            <FormControl sx={{ mt: 1, minWidth: 350, maxWidth: 350 }}>
              <InputLabel size="small" className="select-default-label">
                Referral Type
              </InputLabel>
              <Select
                value={ReferralType}
                name="Referral Type"
                label="Referral Type"
                onChange={handleReferralType}
                size="small"
                sx={{ borderRadius: 20 }}
              >
                <MenuItem value="Client Referral to another Agent">
                  Client Referral to another Agent
                </MenuItem>

                <MenuItem value="Referral to Builder">
                  Referral to Builder
                </MenuItem>
                <MenuItem value="Referral to 3rd Party">
                  Referral to 3rd Party (Mortgage Broker, etc.)
                </MenuItem>
                <MenuItem value="Transaction/Referral Payment to another Agent">
                  Transaction/Referral Payment to another Agent
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>
        </div>
      </div>

      {ReferralType === "Client Referral to another Agent" ||
      ReferralType === "Transaction/Referral Payment to another Agent" ? (
        <ChecklistCard
          province={"SK"}
          Title1={""}
          CheckListData={ReferralData}
          Header={ReferralType}
          Header2={""}
        />
      ) : (
        ""
      )}
      {ReferralType === "Referral to Builder" ? (
        <ChecklistCard
          province={"SK"}
          Title1={""}
          CheckListData={PreConReferralData}
          Header={"Referral of Client to Builder"}
          Header2={""}
        />
      ) : (
        ""
      )}
      {ReferralType === "Referral to 3rd Party" ? (
        <ChecklistCard
          province={"SK"}
          Title1={""}
          CheckListData={["Disclosure of Benefit (610)"]}
          Header={"Referral of Client to 3rd Party (Mortgage Broker, etc.)"}
          Header2={""}
        />
      ) : (
        ""
      )}
      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>

        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("referral") === true
          )}
        />
      </div>
    </div>
  );
}
